import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, withCtx as _withCtx, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from './../../assets/arrow-box.png'
import _imports_1 from './../../assets/arrow-box-left.png'


const _withScopeId = n => (_pushScopeId("data-v-08867f1b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page" }
const _hoisted_2 = { class: "filter-sec" }
const _hoisted_3 = { class: "filters-container" }
const _hoisted_4 = { class: "top-rowe rowe" }
const _hoisted_5 = { class: "rowe" }
const _hoisted_6 = ["value", "selected", "onClick"]
const _hoisted_7 = { class: "colu" }
const _hoisted_8 = { class: "filter-btns-container" }
const _hoisted_9 = {
  key: 0,
  class: "calendar-filters"
}
const _hoisted_10 = { class: "cards-sec" }
const _hoisted_11 = { class: "cards-container" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "bar brown-bar" }, null, -1))
const _hoisted_13 = { class: "txt-container" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "name" }, "New Booking", -1))
const _hoisted_15 = { class: "num" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "bar light-brown-bar" }, null, -1))
const _hoisted_17 = { class: "txt-container" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "name" }, "Scheduled", -1))
const _hoisted_19 = { class: "num" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "bar green-bar" }, null, -1))
const _hoisted_21 = { class: "txt-container" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "name" }, "Check In", -1))
const _hoisted_23 = { class: "num" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "radial-container green-rad" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "circle" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_0,
      class: "icon-img"
    })
  ])
], -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "bar red-bar" }, null, -1))
const _hoisted_26 = { class: "txt-container" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "name" }, "Check Out", -1))
const _hoisted_28 = { class: "num" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "radial-container red-rad" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "circle" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_1,
      class: "icon-img left"
    })
  ])
], -1))
const _hoisted_30 = { class: "stats-sec" }
const _hoisted_31 = { class: "stats-container" }
const _hoisted_32 = { class: "colu stats-col" }
const _hoisted_33 = { class: "avail-rooms-container room-stat-container" }
const _hoisted_34 = { class: "progress-container" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "heading" }, "Available Rooms Today", -1))
const _hoisted_36 = { class: "progress" }
const _hoisted_37 = ["aria-valuenow", "aria-valuemax"]
const _hoisted_38 = { class: "number" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "sep" }, null, -1))
const _hoisted_40 = { class: "occ-rooms-container room-stat-container" }
const _hoisted_41 = { class: "progress-container" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "heading" }, "Occupied Rooms Today", -1))
const _hoisted_43 = { class: "progress" }
const _hoisted_44 = ["aria-valuenow", "aria-valuemax"]
const _hoisted_45 = { class: "number" }
const _hoisted_46 = { class: "rowe" }
const _hoisted_47 = { class: "revenue-container" }
const _hoisted_48 = { class: "txt-container" }
const _hoisted_49 = { class: "colu" }
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "title" }, "Total Revenue", -1))
const _hoisted_51 = { class: "heading" }
const _hoisted_52 = { class: "colu" }
const _hoisted_53 = { class: "number" }
const _hoisted_54 = { class: "stats-container" }
const _hoisted_55 = { class: "revenue-card" }
const _hoisted_56 = { class: "txt-container" }
const _hoisted_57 = { class: "colu" }
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "title" }, "Income", -1))
const _hoisted_59 = { class: "heading" }
const _hoisted_60 = { class: "colu" }
const _hoisted_61 = { class: "number" }
const _hoisted_62 = { class: "stats-container" }
const _hoisted_63 = { class: "colu sec-colu" }
const _hoisted_64 = { class: "bookings-container" }
const _hoisted_65 = { class: "rowe" }
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "heading" }, "Newest Bookings", -1))
const _hoisted_67 = /*#__PURE__*/_createTextVNode("view all ")
const _hoisted_68 = { class: "rowe rowe-1 flex-apart" }
const _hoisted_69 = { class: "date" }
const _hoisted_70 = { class: "apartment" }
const _hoisted_71 = { class: "rowe rowe-2 flex-apart" }
const _hoisted_72 = { class: "name" }
const _hoisted_73 = { class: "amount" }
const _hoisted_74 = { class: "rowe rowe-2 flex-apart" }
const _hoisted_75 = { class: "name" }
const _hoisted_76 = {
  key: 0,
  class: "paid"
}
const _hoisted_77 = {
  key: 1,
  class: "partial"
}
const _hoisted_78 = { key: 0 }
const _hoisted_79 = { class: "rowe rowe-2 flex-apart" }
const _hoisted_80 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "name" }, "check in", -1))
const _hoisted_81 = { class: "amount" }
const _hoisted_82 = { class: "rowe rowe-2 flex-apart" }
const _hoisted_83 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "name" }, "check out", -1))
const _hoisted_84 = { class: "amount" }
const _hoisted_85 = { class: "rowe rowe-3" }
const _hoisted_86 = ["onClick"]
const _hoisted_87 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-angles-down" }, null, -1))
const _hoisted_88 = [
  _hoisted_87
]
const _hoisted_89 = { class: "btm-sec" }
const _hoisted_90 = { class: "btm-container" }
const _hoisted_91 = { class: "colu" }
const _hoisted_92 = { class: "calendar-card card" }
const _hoisted_93 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "heading" }, "Booking Calendar", -1))
const _hoisted_94 = { class: "calendar-container" }
const _hoisted_95 = { class: "colu" }
const _hoisted_96 = { class: "tasks-card card" }
const _hoisted_97 = { class: "rowe" }
const _hoisted_98 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "heading" }, "Today's Tasks", -1))
const _hoisted_99 = /*#__PURE__*/_createTextVNode("view all ")
const _hoisted_100 = { class: "tasks-container" }
const _hoisted_101 = { class: "txt-container" }
const _hoisted_102 = { class: "name" }
const _hoisted_103 = { class: "date" }
const _hoisted_104 = {
  key: 0,
  class: "state-container pending"
}
const _hoisted_105 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "state" }, "pending", -1))
const _hoisted_106 = [
  _hoisted_105
]
const _hoisted_107 = {
  key: 1,
  class: "state-container completed"
}
const _hoisted_108 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "state" }, "completed", -1))
const _hoisted_109 = [
  _hoisted_108
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_OverlayLoader = _resolveComponent("OverlayLoader")!
  const _component_Calendar = _resolveComponent("Calendar")!
  const _component_Knob = _resolveComponent("Knob")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_BarChart = _resolveComponent("BarChart")!
  const _component_highcharts = _resolveComponent("highcharts")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.load)
      ? (_openBlock(), _createBlock(_component_OverlayLoader, { key: 0 }))
      : _createCommentVNode("", true),
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("select", {
              class: "custom-select in select-in",
              placeholder: "switch building",
              onChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.switchBuilding($event.target.value)))
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.buildings, (building) => {
                return (_openBlock(), _createElementBlock("option", {
                  value: building._id,
                  key: building._id,
                  selected: building._id == _ctx.currentBuilding._id,
                  onClick: ($event: any) => (_ctx.switchBuilding(building))
                }, _toDisplayString(building.name), 9, _hoisted_6))
              }), 128))
            ], 32)
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("button", {
                class: _normalizeClass(["filter-btn", { active: _ctx.period == 'This year' }]),
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.filterPeriod('This year')))
              }, "This year", 2),
              _createElementVNode("button", {
                class: _normalizeClass(["filter-btn", { active: _ctx.period == 'This month' }]),
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.filterPeriod('This month')))
              }, "This Month", 2),
              _createElementVNode("button", {
                class: _normalizeClass(["filter-btn", { active: _ctx.period == 'This week' }]),
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.filterPeriod('This week')))
              }, "This week", 2),
              _createElementVNode("button", {
                class: _normalizeClass(["filter-btn", { active: _ctx.period == 'custom' }]),
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.period = 'custom'))
              }, "Choose period", 2)
            ]),
            (_ctx.period == 'custom')
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                  _createVNode(_component_Calendar, {
                    modelValue: _ctx.calendarStart,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.calendarStart) = $event)),
                    placeholder: "enter start date",
                    dateFormat: "dd/mm/yy",
                    onDateSelect: _cache[6] || (_cache[6] = ($event: any) => (_ctx.customFilter())),
                    showIcon: true,
                    icon: "pi pi-calendar"
                  }, null, 8, ["modelValue"]),
                  _createVNode(_component_Calendar, {
                    modelValue: _ctx.calendarEnd,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.calendarEnd) = $event)),
                    placeholder: "enter end date",
                    dateFormat: "dd/mm/yy",
                    onDateSelect: _cache[8] || (_cache[8] = ($event: any) => (_ctx.customFilter())),
                    showIcon: true,
                    icon: "pi pi-calendar"
                  }, null, 8, ["modelValue"])
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ]),
    _createElementVNode("section", _hoisted_10, [
      _createElementVNode("div", _hoisted_11, [
        _createVNode(_component_router_link, {
          to: { name: 'Calendar', params: { building: _ctx.$route.params.building } },
          class: "card booking-card"
        }, {
          default: _withCtx(() => [
            _hoisted_12,
            _createElementVNode("div", _hoisted_13, [
              _hoisted_14,
              _createElementVNode("h3", _hoisted_15, _toDisplayString(_ctx.bookingsNumber), 1)
            ]),
            _createVNode(_component_Knob, {
              modelValue: _ctx.bookingsNumber,
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.bookingsNumber) = $event)),
              readonly: true,
              strokeWidth: 5,
              min: 0,
              max: 50,
              rangeColor: 'rgb(201, 201, 201)',
              valueColor: '#c5a753',
              valueTemplate: _ctx.bookingsNumber + '%'
            }, null, 8, ["modelValue", "rangeColor", "valueTemplate"])
          ]),
          _: 1
        }, 8, ["to"]),
        _createVNode(_component_router_link, {
          to: { name: 'Calendar', params: { building: _ctx.$route.params.building } },
          class: "card booking-card"
        }, {
          default: _withCtx(() => [
            _hoisted_16,
            _createElementVNode("div", _hoisted_17, [
              _hoisted_18,
              _createElementVNode("h3", _hoisted_19, _toDisplayString(_ctx.checkIns), 1)
            ]),
            _createVNode(_component_Knob, {
              modelValue: _ctx.checkIns,
              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.checkIns) = $event)),
              readonly: true,
              strokeWidth: 5,
              min: 0,
              max: 50,
              rangeColor: 'rgb(201, 201, 201)',
              valueColor: '#c5a753',
              valueTemplate: _ctx.checkIns + '%'
            }, null, 8, ["modelValue", "rangeColor", "valueTemplate"])
          ]),
          _: 1
        }, 8, ["to"]),
        _createVNode(_component_router_link, {
          to: { name: 'Calendar', params: { building: _ctx.$route.params.building } },
          class: "card booking-card"
        }, {
          default: _withCtx(() => [
            _hoisted_20,
            _createElementVNode("div", _hoisted_21, [
              _hoisted_22,
              _createElementVNode("h3", _hoisted_23, _toDisplayString(_ctx.checkIns), 1)
            ]),
            _hoisted_24
          ]),
          _: 1
        }, 8, ["to"]),
        _createVNode(_component_router_link, {
          to: { name: 'Calendar', params: { building: _ctx.$route.params.building } },
          class: "card booking-card"
        }, {
          default: _withCtx(() => [
            _hoisted_25,
            _createElementVNode("div", _hoisted_26, [
              _hoisted_27,
              _createElementVNode("h3", _hoisted_28, _toDisplayString(_ctx.checkOuts), 1)
            ]),
            _hoisted_29
          ]),
          _: 1
        }, 8, ["to"])
      ])
    ]),
    _createElementVNode("section", _hoisted_30, [
      _createElementVNode("div", _hoisted_31, [
        _createElementVNode("div", _hoisted_32, [
          _createVNode(_component_router_link, {
            to: { name: 'Apartments', params: { building: _ctx.$route.params.building } },
            class: "avail-container"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_33, [
                _createElementVNode("div", _hoisted_34, [
                  _hoisted_35,
                  _createElementVNode("div", _hoisted_36, [
                    _createElementVNode("div", {
                      class: "progress-bar available-progress",
                      role: "progressbar",
                      style: _normalizeStyle({ width: ((_ctx.freeApartments / _ctx.totalApartments) * 100) + '%' }),
                      "aria-valuenow": _ctx.freeApartments,
                      "aria-valuemin": "0",
                      "aria-valuemax": _ctx.totalApartments
                    }, null, 12, _hoisted_37)
                  ])
                ]),
                _createElementVNode("h3", _hoisted_38, _toDisplayString(_ctx.freeApartments), 1)
              ]),
              _hoisted_39,
              _createElementVNode("div", _hoisted_40, [
                _createElementVNode("div", _hoisted_41, [
                  _hoisted_42,
                  _createElementVNode("div", _hoisted_43, [
                    _createElementVNode("div", {
                      class: "progress-bar occupied-progress",
                      role: "progressbar",
                      style: _normalizeStyle({ width: (((_ctx.totalApartments - _ctx.freeApartments) / _ctx.totalApartments) * 100) + '%' }),
                      "aria-valuenow": (_ctx.totalApartments - _ctx.freeApartments),
                      "aria-valuemin": "0",
                      "aria-valuemax": _ctx.totalApartments
                    }, null, 12, _hoisted_44)
                  ])
                ]),
                _createElementVNode("h3", _hoisted_45, _toDisplayString((_ctx.totalApartments - _ctx.freeApartments)), 1)
              ])
            ]),
            _: 1
          }, 8, ["to"]),
          _createElementVNode("div", _hoisted_46, [
            _createElementVNode("div", _hoisted_47, [
              _createElementVNode("div", _hoisted_48, [
                _createElementVNode("div", _hoisted_49, [
                  _hoisted_50,
                  _createElementVNode("h5", _hoisted_51, _toDisplayString(_ctx.period), 1)
                ]),
                _createElementVNode("div", _hoisted_52, [
                  _createElementVNode("h3", _hoisted_53, "FCFA " + _toDisplayString(_ctx.totalIncome.toLocaleString()), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_54, [
                _createVNode(_component_BarChart, {
                  chartData: _ctx.revenueData,
                  "css-classes": "chart",
                  options: _ctx.options
                }, null, 8, ["chartData", "options"])
              ])
            ]),
            _createElementVNode("div", _hoisted_55, [
              _createElementVNode("div", _hoisted_56, [
                _createElementVNode("div", _hoisted_57, [
                  _hoisted_58,
                  _createElementVNode("h4", _hoisted_59, _toDisplayString(_ctx.period), 1)
                ]),
                _createElementVNode("div", _hoisted_60, [
                  _createElementVNode("h3", _hoisted_61, "FCFA " + _toDisplayString((_ctx.totalIncome - _ctx.totalExpense).toLocaleString()), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_62, [
                _createVNode(_component_BarChart, {
                  chartData: _ctx.incomeData,
                  "css-classes": "chart",
                  options: _ctx.options
                }, null, 8, ["chartData", "options"])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_63, [
          _createElementVNode("div", _hoisted_64, [
            _createElementVNode("div", _hoisted_65, [
              _hoisted_66,
              _createVNode(_component_router_link, {
                class: "details-link",
                to: { name: 'Calendar', params: { building: _ctx.$route.params.building } }
              }, {
                default: _withCtx(() => [
                  _hoisted_67
                ]),
                _: 1
              }, 8, ["to"])
            ]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.bookings, (booking) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "booking-card",
                key: booking._id
              }, [
                _createElementVNode("div", _hoisted_68, [
                  _createElementVNode("h3", _hoisted_69, _toDisplayString(_ctx.getReadDateNotTime(booking.check_in)), 1),
                  _createElementVNode("h5", _hoisted_70, "Apartment " + _toDisplayString(booking.apartmentDetails?.name), 1)
                ]),
                _createElementVNode("div", _hoisted_71, [
                  _createElementVNode("h3", _hoisted_72, _toDisplayString(booking.clientDetails?.name), 1),
                  _createElementVNode("h5", _hoisted_73, _toDisplayString(booking.amount_to_pay.toLocaleString()) + " FCFA", 1)
                ]),
                _createElementVNode("div", _hoisted_74, [
                  _createElementVNode("h3", _hoisted_75, [
                    (booking.paid)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_76, "paid"))
                      : _createCommentVNode("", true),
                    (!booking.paid)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_77, "partially paid"))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("h5", {
                    class: _normalizeClass(["amount", { partial: !booking.paid, paid: booking.paid }])
                  }, _toDisplayString(booking.amount_paid.toLocaleString()) + " FCFA", 3)
                ]),
                (_ctx.currentBooking._id == booking._id && _ctx.moreBookingDetails)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_78, [
                      _createElementVNode("div", _hoisted_79, [
                        _hoisted_80,
                        _createElementVNode("h5", _hoisted_81, _toDisplayString(_ctx.getReadDate(booking.check_in)), 1)
                      ]),
                      _createElementVNode("div", _hoisted_82, [
                        _hoisted_83,
                        _createElementVNode("h5", _hoisted_84, _toDisplayString(_ctx.getReadDate(booking.check_out)), 1)
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_85, [
                  _createElementVNode("button", {
                    class: _normalizeClass(["details-btn", { rotated: _ctx.currentBooking._id == booking._id && _ctx.moreBookingDetails }]),
                    onClick: ($event: any) => (_ctx.showMoreBookingDetails(booking)),
                    "data-toggle": "tooltip",
                    "data-placement": "top",
                    title: "Show more details"
                  }, _hoisted_88, 10, _hoisted_86)
                ])
              ]))
            }), 128))
          ])
        ])
      ])
    ]),
    _createElementVNode("section", _hoisted_89, [
      _createElementVNode("div", _hoisted_90, [
        _createElementVNode("div", _hoisted_91, [
          _createElementVNode("div", _hoisted_92, [
            _hoisted_93,
            _createElementVNode("div", _hoisted_94, [
              _createVNode(_component_highcharts, {
                id: "calendar",
                options: _ctx.chartState.chartOptions
              }, null, 8, ["options"])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_95, [
          _createElementVNode("div", _hoisted_96, [
            _createElementVNode("div", _hoisted_97, [
              _hoisted_98,
              _createVNode(_component_router_link, {
                class: "details-link",
                to: { name: 'Tasks', params: { building: _ctx.$route.params.building } }
              }, {
                default: _withCtx(() => [
                  _hoisted_99
                ]),
                _: 1
              }, 8, ["to"])
            ]),
            _createElementVNode("div", _hoisted_100, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tasks, (task) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "task",
                  key: task._id
                }, [
                  _createElementVNode("div", _hoisted_101, [
                    _createElementVNode("h5", _hoisted_102, _toDisplayString(task.name), 1),
                    _createElementVNode("h6", _hoisted_103, _toDisplayString(_ctx.getReadDate(task.created_at)), 1)
                  ]),
                  (!task.isCompleted)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_104, _hoisted_106))
                    : _createCommentVNode("", true),
                  (task.isCompleted)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_107, _hoisted_109))
                    : _createCommentVNode("", true)
                ]))
              }), 128))
            ])
          ])
        ])
      ])
    ])
  ]))
}